// GA4 + Yandex Metrika event helpers. gtag()/ym() are loaded via public/index.html.
const CURRENCY = 'RUB';

const gtagEvent = (name, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};

// Metrika init uses defer:true (no auto hit), so hits are sent manually on route change
const ymHit = (path) => {
  if (typeof window === 'undefined' || typeof window.ym !== 'function' || !window.YM_COUNTER_ID) return;
  window.ym(window.YM_COUNTER_ID, 'hit', window.location.origin + path);
};

const adToItem = (ad, index) => ({
  item_id: String(ad.id),
  item_name: ad.title,
  item_category: ad.propertyKind,
  price: ad.price ?? 0,
  currency: CURRENCY,
  ...(index != null ? { index } : {}),
});

export const trackPageView = (path) => {
  gtagEvent('page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
  ymHit(path);
};

export const trackViewItem = (ad) => {
  if (!ad) return;
  gtagEvent('view_item', {
    currency: CURRENCY,
    value: ad.price ?? 0,
    items: [adToItem(ad)],
  });
};

export const trackViewItemList = (ads, listName) => {
  if (!ads?.length) return;
  gtagEvent('view_item_list', {
    item_list_name: listName,
    items: ads.map((ad, i) => adToItem(ad, i)),
  });
};

export const trackSelectItem = (ad, listName) => {
  if (!ad) return;
  gtagEvent('select_item', {
    item_list_name: listName,
    items: [adToItem(ad)],
  });
};

export const trackAddToWishlist = (ad) => {
  if (!ad) return;
  gtagEvent('add_to_wishlist', {
    currency: CURRENCY,
    value: ad.price ?? 0,
    items: [adToItem(ad)],
  });
};

// lead_source: 'phone' | 'chat'
export const trackGenerateLead = (ad, leadSource) => {
  gtagEvent('generate_lead', {
    currency: CURRENCY,
    value: ad?.price ?? 0,
    lead_source: leadSource,
    items: ad ? [adToItem(ad)] : undefined,
  });
};

export const trackSignUp = (method = 'email') => {
  gtagEvent('sign_up', { method });
};

export const trackLogin = (method = 'email') => {
  gtagEvent('login', { method });
};

// Custom event: not a GA4 recommended event, tracks seller-side conversion
export const trackPublishAd = (ad) => {
  gtagEvent('publish_ad', {
    item_id: ad?.id != null ? String(ad.id) : undefined,
    item_category: ad?.propertyKind,
    deal_type: ad?.dealType,
    value: ad?.price ?? 0,
    currency: CURRENCY,
  });
};
